import type { ReactNode } from "react";

import { Button, classNames } from "@alpacahq/ui/old";

type FloatingButtonProps = {
  label?: string;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  type?: "button" | "submit";
};

export interface FloatingButtonsProps {
  next?: FloatingButtonProps;
  back?: FloatingButtonProps;
  className?: string;
  fixedOnBottom?: boolean;
  fixedContainerClassName?: string;
  topContent?: ReactNode;
}

export const FloatingButtons = ({
  back,
  next,
  className,
  fixedOnBottom,
  fixedContainerClassName,
  topContent,
}: FloatingButtonsProps) => {
  const buttons = (
    <>
      {back && (
        <Button
          variant="v2/stroke"
          onClick={back.onClick}
          disabled={back.disabled}
          loading={back.loading}
          type={back.type ?? "button"}
        >
          {back.label ?? "Back"}
        </Button>
      )}
      {next && (
        <Button
          variant="v2/filled"
          onClick={next.onClick}
          disabled={next.disabled}
          loading={next.loading}
          type={next.type ?? "button"}
        >
          {next.label ?? "Continue"}
        </Button>
      )}
    </>
  );

  return (
    <>
      {(back || next) && (
        <>
          {fixedOnBottom && (
            <div className={classNames(topContent ? "h-32" : "h-16")} />
          )}
          <div
            className={classNames(
              "flex w-full flex-col gap-2 py-2",
              fixedOnBottom &&
                "fixed right-0 bottom-0 left-0 z-10 mx-auto border-gray-300 border-t bg-gray-50",
              className,
            )}
          >
            {fixedOnBottom ? (
              <div
                className={classNames(
                  "mx-auto flex w-full max-w-[648px] flex-col gap-3 px-6",
                  fixedContainerClassName,
                )}
              >
                {topContent}
                <div
                  className={classNames(
                    "flex items-center justify-between gap-4",
                    !back && "justify-end",
                  )}
                >
                  {buttons}
                </div>
              </div>
            ) : (
              <>
                {topContent}
                <div
                  className={classNames(
                    "flex items-center justify-between gap-4",
                    !back && "justify-end",
                  )}
                >
                  {buttons}
                </div>
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};
